import { render } from "./ProjectList.vue?vue&type=template&id=75fa942c&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=75fa942c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fa942c"]])

export default __exports__